import { SIDE_TYPE } from "@/commons/enums/side-type";
import localStore from "@/commons/store/local-store";
// 项目
import ModelFilePanel from "@/panel/project/model-file";
// 场地规划
import RoadNetworkPanel from "@/panel/planning/road-network-panel";
import RoadPanel from "@/panel/planning/road-panel";
import FencePanel from "@/panel/planning/fence";
import GroundPanel from "@/panel/planning/ground";
import ParkingSpace from "@/panel/planning/parking-space";
import NoMotorParkingSpace from "@/panel/planning/no-motor-parking-space";
import TreePanel from "@/panel/planning/tree";
import StreetLamp from "@/panel/planning/street-lamp";

// 建筑
import StationPanel from "@/panel/building/station";
import RoofSlab from "@/panel/building/roof-slab";
import { FloorPanel } from "@/panel/building/floor";
import AxisNetPanel from "@/panel/building/axis-net";
import { useEffect, useState } from "react";
import { CeilingPanel } from "@/panel/building/ceiling";
import WallPanel from "@/panel/building/wall";
import ColumnPanel from "@/panel/building/column";
import ElevatorCarPanel from "@/panel/building/elevator-car";
import { StoreyPanel } from "@/panel/building/storey";
import HolePanel from "@/panel/building/hole";
import DoorPanel from "@/panel/building/door";
import WindowPanel from "@/panel/building/window";
import EavesBoardPanel from "@/panel/building/eaves-board";
import Gutter from "@/panel/building/gutter";

// 结构
import SectionPanel from "@/panel/spec-common/section";
import SBeamPanel from "@/panel/structure/beam";
import ProMaterialPanel from "@/panel/spec-common/material";
import SColumnPanel from "@/panel/structure/column";
import SBarPanel from "@/panel/structure/bar";
import SBracePanel from "@/panel/structure/brace";
import SWallPanel from "@/panel/structure/wall";
import SFloorPanel from "@/panel/structure/floor";
// 暖通
import HavcTunnelBlockPanel from "@/panel/havc/tunnel_block";
import HavcTunnelConnectPanel from "@/panel/havc/tunnel_connect";
import HavcDeviceBlockPanel from "@/panel/havc/device_block";

// 消防
import { SmokeDetectorPanel } from "@/panel/fire/smoke-detector";
import { FireExtinguisherPanel } from "@/panel/fire/fire-extinguisher";
import { SprayHeadPanel } from "@/panel/fire/spray-head";
import { FireHydrantPanel } from "@/panel/fire/fire-hydrant";

// 运维
import { PatrolPointPanel } from "@/panel/maint/patrol-point";
import SensorContainer from "@/panel/maint/device/sensor";
import { SENSOR_TYPE } from "@/commons/enums/sensor-type";
import DataBoxPanel from "@/panel/maint/device/collection-device";
import { DATA_BOX_TYPE } from "@/commons/enums/data-box-type";
import CablePanel from "@/panel/maint/device/cable";

// 通用
import TexturePanel from "@/panel/spec-common/texture";
import ComponentPanel from "@/panel/spec-common/component";
import RoomPanel from "@/panel/building/room";
import ElevatorPanel from "@/panel/building/elevator";
import PumpRoomPanel from "@/panel/building/pump-room";
import FireControlRoomPanel from "@/panel/building/fire-control-room";
import RoamRoutePanel from "@/panel/building/roam-route";
import BackupPanel from "@/panel/project/backup";
import { MonitorPanel } from "@/panel/maint/monitor";
import GroupPanel from "@/panel/project/group";
import FireTunnelBlockPanel from "@/panel/fire/fire-tunnel";
import PermissionPanel from "@/panel/project/permission";
import { FireShutterPanel } from "@/panel/fire/fire-shutter";
import SmokeTunnelBlockPanel from "@/panel/fire/smoke-tunnel";
import RenderDataPanel from "@/panel/building/render-data";
import EscapeRoutePanel from "@/panel/building/escape-route";
import ElevatorGroupPanel from "@/panel/building/elevator-group";


interface Iprops {
    width: number;
}
export default function SideBar(props: Iprops) {
    const [sidePanel, setSidePanel] = useState<string>("");

    useEffect(() => {
        setSidePanel(localStore.selectedPanel);
    }, [localStore.selectedPanel]);

    return (
        <div style={{
            height: '100%'
        }}>
            {sidePanel === SIDE_TYPE.model && <ModelFilePanel />}
            {/* 组 */}
            {sidePanel == SIDE_TYPE.group && <GroupPanel />}

            {sidePanel === SIDE_TYPE.road_network && <RoadNetworkPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.ground && <GroundPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.road && <RoadPanel width={props.width} />}

            {sidePanel === SIDE_TYPE.axis_net && <AxisNetPanel />}
            {sidePanel === SIDE_TYPE.fence && <FencePanel />}
            {sidePanel === SIDE_TYPE.hole && <HolePanel />}
            {sidePanel === SIDE_TYPE.floor && <FloorPanel />}
            {sidePanel === SIDE_TYPE.ceiling && <CeilingPanel />}
            {sidePanel === SIDE_TYPE.wall && <WallPanel />}

            {sidePanel === SIDE_TYPE.column && <ColumnPanel />}

            {sidePanel === SIDE_TYPE.elevator_car && <ElevatorCarPanel />}
            {sidePanel === SIDE_TYPE.door && <DoorPanel />}
            {sidePanel === SIDE_TYPE.window && <WindowPanel />}

            {sidePanel === SIDE_TYPE.texture && <TexturePanel />}

            {sidePanel === SIDE_TYPE.parking_space && <ParkingSpace />}
            {sidePanel === SIDE_TYPE.no_motor_parking_space && <NoMotorParkingSpace />}

            {sidePanel === SIDE_TYPE.storey && <StoreyPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.room && <RoomPanel />}
            {sidePanel === SIDE_TYPE.elevator && <ElevatorPanel />}
            {sidePanel === SIDE_TYPE.pump_room && <PumpRoomPanel />}
            {sidePanel === SIDE_TYPE.patrol_point && <PatrolPointPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.fire_control_room && <FireControlRoomPanel />}
            {sidePanel === SIDE_TYPE.escape_route && <EscapeRoutePanel />}
            {sidePanel === SIDE_TYPE.elevator_group && <ElevatorGroupPanel />}
            {sidePanel === SIDE_TYPE.tree && <TreePanel />}
            {sidePanel === SIDE_TYPE.roam_route && <RoamRoutePanel />}

            {sidePanel === SIDE_TYPE.smoke_detector && <SmokeDetectorPanel />}
            {sidePanel === SIDE_TYPE.fire_extinguisher && <FireExtinguisherPanel />}
            {sidePanel === SIDE_TYPE.spray_head && <SprayHeadPanel />}
            {sidePanel === SIDE_TYPE.fire_hydrant && <FireHydrantPanel />}
            {sidePanel === SIDE_TYPE.component && <ComponentPanel />}
            {sidePanel === SIDE_TYPE.street_lamp && <StreetLamp />}

            {sidePanel === SIDE_TYPE.section && <SectionPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.material && <ProMaterialPanel width={props.width} />}
            {sidePanel === SIDE_TYPE.structure_beam && <SBeamPanel />}
            {sidePanel === SIDE_TYPE.structure_column && <SColumnPanel />}
            {sidePanel === SIDE_TYPE.structure_bar && <SBarPanel />}
            {sidePanel === SIDE_TYPE.structure_brace && <SBracePanel />}
            {sidePanel === SIDE_TYPE.structure_wall && <SWallPanel />}
            {sidePanel === SIDE_TYPE.structure_floor && <SFloorPanel />}

            {sidePanel === SIDE_TYPE.tunnel_block && <HavcTunnelBlockPanel />}
            {sidePanel === SIDE_TYPE.connect_block && <HavcTunnelConnectPanel />}
            {sidePanel === SIDE_TYPE.device_block && <HavcDeviceBlockPanel />}

            {sidePanel === SIDE_TYPE.station && <StationPanel />}
            {sidePanel === SIDE_TYPE.roof_slab && <RoofSlab />}
            {sidePanel === SIDE_TYPE.eaves_board && <EavesBoardPanel />}
            {sidePanel === SIDE_TYPE.gutter && <Gutter />}

            {/* 巡检-摄像头 */}
            {sidePanel === SIDE_TYPE.monitor && <MonitorPanel width={props.width} />}
            {/* 消防管道 */}
            {sidePanel === SIDE_TYPE.fire_tunnel_block && <FireTunnelBlockPanel />}
            {/* 防火卷帘 */}
            {sidePanel === SIDE_TYPE.fire_shutter && <FireShutterPanel />}
            {/* 排烟送风管道 */}
            {sidePanel === SIDE_TYPE.smoke_tunnel_block && <SmokeTunnelBlockPanel />}

            {/* 巡检-摄像头 */}
            {sidePanel === SIDE_TYPE.monitor && <MonitorPanel width={props.width} />}
            {/* 监测-摄像头 */}
            {sidePanel === SIDE_TYPE.camera && <SensorContainer sensorType={SENSOR_TYPE.CAMERA} />}
            {/* 水位计 */}
            {sidePanel === SIDE_TYPE.water_level_gauge && <SensorContainer sensorType={SENSOR_TYPE.FLUVIOGRAPH} />}
            {/* 风速风向仪 */}
            {sidePanel === SIDE_TYPE.anemoclinograph && <SensorContainer sensorType={SENSOR_TYPE.ANEMOCLINOGRAPH} />}
            {/* 串口设备 */}
            {sidePanel === SIDE_TYPE.serial_device && <DataBoxPanel dataBoxType={DATA_BOX_TYPE.SERIAL} />}
            {/* 硬盘录像机 */}
            {sidePanel === SIDE_TYPE.dvr && <DataBoxPanel dataBoxType={DATA_BOX_TYPE.DVR} />}
            {/* 数据线缆 */}
            {sidePanel == SIDE_TYPE.cable && <CablePanel />}
            {/* 备份列表 */}
            {sidePanel == SIDE_TYPE.backup && <BackupPanel />}
            {/* 权限 */}
            {sidePanel == SIDE_TYPE.permission && <PermissionPanel />}
            {/* 导出渲染模型 */}
            {sidePanel == SIDE_TYPE.render_data && <RenderDataPanel />}
        </div>
    )
}

